import { Type } from "@angular/core";
import { RecentLogComponent } from './recent-log.component';

export * from "./recent-log.component";

export const LOG_DIRECTIVES: Type<any>[] = [
    RecentLogComponent
];
